// escapeToInnerPeaceRoutes.jsx
// Dedicated, isolated route tree for Escape to Inner Peace — kept separate
// from the 28 States "*" route group in src/index.js so this game can be
// built and tested without touching existing 28 States flows.
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from '../pages/escape-to-inner-peace/landing/LandingPage';
import IntroPage from '../pages/escape-to-inner-peace/intro/IntroPage';
import RulesPage from '../pages/escape-to-inner-peace/rules/RulesPage';
import GamePage from '../pages/escape-to-inner-peace/game/GamePage';
import ResultPage from '../pages/escape-to-inner-peace/result/ResultPage';
import { useEscapeGuestBootstrap } from '../games/escape-to-inner-peace/hooks/useEscapeGuestBootstrap';

const GAME_TITLE = 'Escape to Inner Peace';

function EscapeToInnerPeaceRoutes() {
  // Set once for the whole route tree (not per-page) — this component stays
  // mounted across internal navigation (landing -> intro -> ... -> result),
  // so the title only needs to be restored when leaving the game entirely
  // (e.g. the header's Back button), not on every sub-route change. Never
  // touches public/index.html's default title, which 28 States pages keep.
  useEffect(() => {
    const previousTitle = document.title;
    document.title = GAME_TITLE;
    return () => {
      document.title = previousTitle;
    };
  }, []);

  // Must resolve before any child route mounts — see useEscapeGuestBootstrap
  // for why (useEscapeReplayStatus captures sessionStorage on first mount).
  const guestBootstrapReady = useEscapeGuestBootstrap();
  if (!guestBootstrapReady) return null;

  return (
    <Routes>
      <Route index element={<LandingPage />} />
      <Route path="intro" element={<IntroPage />} />
      <Route path="rules" element={<RulesPage />} />
      <Route path="game" element={<GamePage />} />
      <Route path="result" element={<ResultPage />} />
    </Routes>
  );
}

export default EscapeToInnerPeaceRoutes;
